import moment from "moment";
import React from "react";

// Helpers
import { capitalizeEachWord, capitalizeFirstLetter } from "utils/helpers";

function BasicInfoSummary({ values }) {
  return (
    <div className="bg-gray-100 rounded-lg mx-4 px-6 py-4 md:px-10 md:py-8 space-y-4 sm:space-y-6">
      <p className="uppercase text-lg sm:text-xl xl:text-2xl xl:text-2xl mb-2 md:mb-4 font-bold">
        Candidate Information
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="space-y-2">
          <p className="uppercase  text-sm sm:text-base xl:text-lg text-app-grey font-bold">
            Full Name
          </p>
          <p className="text-sm sm:text-base xl:text-lg lg:text-xl font-medium">
            {capitalizeEachWord(values.full_name)}
          </p>
        </div>
        <div className="space-y-2">
          <p className="uppercase text-sm sm:text-base xl:text-lg  text-app-grey font-bold">
            Date of Evaluation
          </p>
          <p className="text-sm sm:text-base xl:text-lg lg:text-xl font-medium">
            {moment().format("dddd, DD MMMM YYYY")}
          </p>
        </div>
        <div className="space-y-2">
          <p className="uppercase  text-sm sm:text-base xl:text-lg text-app-grey font-bold">
            Email Address
          </p>
          <p className="text-sm sm:text-base xl:text-lg lg:text-xl font-medium">
            {values.email_address}
          </p>
        </div>
        <div className="space-y-2">
          <p className="uppercase  text-sm sm:text-base xl:text-lg text-app-grey font-bold">
            Phone Number
          </p>
          <p className="text-sm sm:text-base xl:text-lg lg:text-xl font-medium">{`${values.phone_code.value}-${values.phone_number}`}</p>
        </div>
        {values.company_name && (
          <div className="space-y-2">
            <p className="uppercase  text-sm sm:text-base xl:text-lg text-app-grey font-bold">
              Company / Organization
            </p>
            <p className="text-sm sm:text-base xl:text-lg lg:text-xl font-medium">
              {capitalizeFirstLetter(values.company_name)}
            </p>
          </div>
        )}
        {values.job_title && (
          <div className="space-y-2">
            <p className="uppercase  text-sm sm:text-base xl:text-lg text-app-grey font-bold">
              Job Title / Position
            </p>
            <p className="text-sm sm:text-base xl:text-lg lg:text-xl font-medium">
              {capitalizeFirstLetter(values.job_title)}
            </p>
          </div>
        )}
      </div>
      <div className="space-y-2">
        <p className="uppercase  text-sm sm:text-base xl:text-lg text-app-grey font-bold">
          Title Program
        </p>
        <p className="text-sky-500 text-lg md:text-2xl xl:text-3xl font-semibold">
          {values.selected_program}
        </p>
      </div>
    </div>
  );
}

export default BasicInfoSummary;
